/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CompanyBrandRef } from './companyBrandRef';
import { ProjectRef } from './projectRef';
import { CompanyRef } from './companyRef';


export interface Forecast { 
    createdAt: string;
    updatedAt?: string;
    createdBy?: string;
    updatedBy?: string;
    _id: string;
    title?: string;
    project?: ProjectRef;
    agency: CompanyRef;
    client: CompanyRef;
    brand: CompanyBrandRef;
    startDateTime: string;
    endDateTime: string;
    description?: string;
    teamForecast: Array<string>;
    totalForecastHrs: number;
    accessKeys: Array<string>;
}

